// ** Redux, Thunk & Root Reducer Imports
import thunk from 'redux-thunk'
import createDebounce from 'redux-debounced'
import rootReducer from '../reducers/rootReducer'
import { createStore, applyMiddleware, compose } from 'redux'

// ** Get User Info from Session Storage
const userInfoFromStorage = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : null

// ** Initial State
const initialState = {
  auth: {
    userData: userInfoFromStorage
  }
}

// ** init middleware
const middleware = [thunk, createDebounce()]

// ** Dev Tools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

// ** Create store
const store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middleware)))

export { store }
